function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { AMPLITUDE_EVENTS } from '../../../constants/analytics';
import { amplitudeTrack } from '../../../utilities';
import HoverableOverlay from '../../hoverableOverlay';
import { DRAWING_ACTIONS, MAP_STATES } from './drawingControls';
import DrawingControlsTooltip from './drawingControlsTooltip';
var SITE_ADDRESS_ENTERED = AMPLITUDE_EVENTS.SITE_ADDRESS_ENTERED;
var DrawingControlsButton = function(param) {
    var state = param.state, mapState = param.mapState, setMapState = param.setMapState, sendDrawingState = param.sendDrawingState, icon = param.icon, tooltip = param.tooltip, isSelected = param.isSelected, isDisabled = param.isDisabled, canDraw = param.canDraw;
    var _useState = _sliced_to_array(useState(false), 2), isHovered = _useState[0], setHovered = _useState[1];
    var _useState1 = _sliced_to_array(useState(''), 2), iconFilter = _useState1[0], setIconFilter = _useState1[1];
    useEffect(function() {
        if (isSelected || isHovered && !isDisabled) {
            setIconFilter('invert(48%) sepia(92%) saturate(669%) hue-rotate(122deg) brightness(95%) contrast(97%)');
        } else {
            setIconFilter('');
        }
    }, [
        isSelected,
        isHovered,
        isDisabled
    ]);
    var onMouseEnter = function() {
        if (!isDisabled) {
            setHovered(true);
        }
    };
    var onMouseLeave = function() {
        if (!isDisabled) {
            setHovered(false);
        }
    };
    return /*#__PURE__*/ React.createElement(HoverableOverlay, {
        placement: "right-start",
        overlay: !isDisabled ? /*#__PURE__*/ React.createElement(DrawingControlsTooltip, {
            text: tooltip
        }) : /*#__PURE__*/ React.createElement(React.Fragment, null)
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames('draw-button', {
            disabled: isDisabled
        }),
        onClick: function() {
            if (!isDisabled) {
                if (state === mapState) {
                    setMapState(MAP_STATES.NONE);
                    sendDrawingState({
                        type: DRAWING_ACTIONS.STOP_DRAWING
                    });
                } else {
                    setMapState(state);
                    if (canDraw) {
                        sendDrawingState({
                            type: DRAWING_ACTIONS.DRAW
                        });
                    }
                }
                amplitudeTrack(SITE_ADDRESS_ENTERED.EVENT, {
                    action: SITE_ADDRESS_ENTERED.CLICK_ON_A_TOOL
                });
            }
        },
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }, /*#__PURE__*/ React.createElement("img", {
        className: "draw-icon",
        style: {
            filter: iconFilter
        },
        src: icon
    })));
};
DrawingControlsButton.propTypes = {
    state: PropTypes.string.isRequired,
    mapState: PropTypes.string.isRequired,
    setMapState: PropTypes.func.isRequired,
    sendDrawingState: PropTypes.func.isRequired,
    icon: PropTypes.string.isRequired,
    tooltip: PropTypes.string.isRequired,
    isSelected: PropTypes.bool,
    isDisabled: PropTypes.bool,
    canDraw: PropTypes.bool
};
export default DrawingControlsButton;
